module.exports = __webpack_public_path__ + "static/img/S.b09f8da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/S.png
// module id = mals
// module chunks = 0